module.exports = __webpack_public_path__ + "img/subscription-selected.2a022bec.png";